import React from 'react';
import { Layout } from '../components/layout/Layout';
import { Hero } from '../components/home/Hero';
import { ServiceFlyers } from '../components/home/ServiceFlyers';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { Calendar, Clock, Play, ArrowRight, BookOpen, Flame, Home } from 'lucide-react';
import { motion } from 'framer-motion';
export function HomePage() {
  return <Layout data-id="element-595">
      <Hero data-id="element-596" />

      {/* SECTION 1: ABOUT US */}
      <section className="pt-16 pb-8 bg-white relative overflow-hidden" data-id="element-597">
        <div className="container-custom" data-id="element-598">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-599">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="py-8 lg:py-12" data-id="element-600">
              <span className="text-[#0A1F44] text-xs font-bold tracking-[0.25em] uppercase mb-3 block" data-id="element-601">
                ABOUT US
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-[#0A1F44] mb-4 leading-tight" data-id="element-602">
                Raising Disciples. Building Families.
                <br data-id="element-603" />
                Changing Nations.
              </h2>
              <p className="text-[#0A1F44]/70 text-base leading-relaxed mb-8 max-w-md" data-id="element-604">
                We are devoted to the Word, the Presence of God, and the power
                of community.
              </p>
              <Link to="/about" data-id="element-605">
                <Button variant="primary" size="md" className="font-bold tracking-wider shadow-lg shadow-red-900/20" data-id="element-606">
                  LEARN MORE <ArrowRight className="w-4 h-4 ml-2" data-id="element-607" />
                </Button>
              </Link>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="relative h-[300px] md:h-[400px] lg:h-[350px]" data-id="element-608">
              <img src="https://cdn.magicpatterns.com/uploads/kQyVAVdgNR28hHw1vzSecz/ChatGPT_Image_Mar_17,_2026,_04_19_27_PM.png" alt="Church Family" className="w-full h-full object-cover object-center" data-id="element-609" />
              {/* Soft fade edges — subtle */}
              <div className="absolute inset-0 pointer-events-none" style={{
              background: 'linear-gradient(to right, white 0%, transparent 8%, transparent 100%)'
            }} data-id="element-610" />
              <div className="absolute inset-0 pointer-events-none" style={{
              background: 'linear-gradient(to left, white 0%, transparent 8%, transparent 100%)'
            }} data-id="element-611" />
              <div className="absolute inset-0 pointer-events-none" style={{
              background: 'linear-gradient(to top, white 0%, transparent 10%, transparent 100%)'
            }} data-id="element-612" />
              <div className="absolute inset-0 pointer-events-none" style={{
              background: 'linear-gradient(to bottom, white 0%, transparent 10%, transparent 100%)'
            }} data-id="element-613" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* SECTION 2: OUR PILLARS */}
      <section className="pt-4 pb-16 bg-white relative" data-id="element-614">
        {/* Subtle gradient background */}
        <div className="absolute inset-0 bg-gradient-to-b from-white via-[#F5F7FA]/60 to-white pointer-events-none" data-id="element-615" />

        <div className="container-custom relative z-10" data-id="element-616">
          <div className="flex items-center justify-center gap-4 md:gap-6 mb-16" data-id="element-617">
            <div className="h-[1px] w-8 sm:w-16 md:w-32 bg-[#C8102E] shrink-0" data-id="element-618" />
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif font-bold text-[#0A1F44] uppercase tracking-wide text-center whitespace-nowrap" data-id="element-619">
              OUR PILLARS
            </h2>
            <div className="h-[1px] w-8 sm:w-16 md:w-32 bg-[#C8102E] shrink-0" data-id="element-620" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-621">
            {/* Pillar 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-white p-10 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] text-center border border-gray-100 hover:-translate-y-2 transition-transform duration-300" data-id="element-622">
              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center text-[#0A1F44]" data-id="element-623">
                <BookOpen className="w-12 h-12" strokeWidth={1.5} data-id="element-624" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#0A1F44] mb-4 uppercase tracking-wide" data-id="element-625">
                THE WORD
              </h3>
              <p className="text-[#0A1F44]/70 text-lg" data-id="element-626">
                Truth that transforms.
              </p>
            </motion.div>

            {/* Pillar 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-white p-10 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] text-center border border-gray-100 hover:-translate-y-2 transition-transform duration-300 relative overflow-hidden" data-id="element-627">
              {/* Subtle red glow behind the flame */}
              <div className="absolute top-10 left-1/2 -translate-x-1/2 w-24 h-24 bg-[#C8102E]/10 blur-2xl rounded-full" data-id="element-628" />

              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center text-[#C8102E] relative z-10" data-id="element-629">
                <Flame className="w-12 h-12" strokeWidth={1.5} data-id="element-630" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#C8102E] mb-4 uppercase tracking-wide relative z-10" data-id="element-631">
                THE PRESENCE
              </h3>
              <p className="text-[#0A1F44]/70 text-lg relative z-10" data-id="element-632">
                Power that changes lives.
              </p>
            </motion.div>

            {/* Pillar 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-white p-10 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] text-center border border-gray-100 hover:-translate-y-2 transition-transform duration-300" data-id="element-633">
              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center text-[#0A1F44]" data-id="element-634">
                <Home className="w-12 h-12" strokeWidth={1.5} data-id="element-635" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#0A1F44] mb-4 uppercase tracking-wide" data-id="element-636">
                THE FAMILY
              </h3>
              <p className="text-[#0A1F44]/70 text-lg" data-id="element-637">Belong. Grow. Serve.</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* SECTION 3: SERVICE TIMES + LATEST SERMON */}
      <section className="bg-gradient-to-br from-[#0A1F44] to-[#163A70] text-white" data-id="element-638">
        <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-639">
          {/* Left Side: Service Times */}
          <div className="p-8 md:p-12 lg:p-16 flex flex-col justify-center items-center lg:items-start lg:pl-[8%] xl:pl-[15%]" data-id="element-640">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="w-full max-w-sm" data-id="element-641">
              <h2 className="text-2xl md:text-3xl font-serif font-bold mb-8 uppercase tracking-widest italic" data-id="element-642">
                SERVICE TIMES
              </h2>

              <div className="space-y-4 mb-8" data-id="element-643">
                <div className="flex items-center gap-4" data-id="element-644">
                  <Calendar className="w-5 h-5 text-white/70 shrink-0" data-id="element-645" />
                  <div className="flex items-center gap-4 text-lg md:text-xl font-bold tracking-wider" data-id="element-646">
                    <span data-id="element-647">SUNDAYS</span>
                    <span className="text-white/90" data-id="element-648">10:00 AM</span>
                  </div>
                </div>

                <div className="flex items-center gap-4" data-id="element-649">
                  <Clock className="w-5 h-5 text-white/70 shrink-0" data-id="element-650" />
                  <div className="flex items-center gap-4 text-lg md:text-xl font-bold tracking-wider" data-id="element-651">
                    <span data-id="element-652">WEDNESDAYS</span>
                    <span className="text-white/90" data-id="element-653">7:00 PM</span>
                  </div>
                </div>
              </div>

              <Link to="/visit" data-id="element-654">
                <Button variant="primary" size="md" className="font-bold tracking-wider px-8 shadow-lg shadow-red-900/40" data-id="element-655">
                  PLAN YOUR VISIT
                </Button>
              </Link>
            </motion.div>
          </div>

          {/* Right Side: Latest Sermon */}
          <div className="relative min-h-[280px] lg:min-h-[320px] flex items-center overflow-hidden group" data-id="element-656">
            {/* Background Image */}
            <div className="absolute inset-0" data-id="element-657">
              <img src="https://images.unsplash.com/photo-1438232992991-995b7058bbb3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Latest Sermon" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-658" />
              <div className="absolute inset-0 bg-[#0A1F44]/60 mix-blend-multiply" data-id="element-659" />
              <div className="absolute inset-0 bg-gradient-to-r from-[#0A1F44]/80 via-[#0A1F44]/40 to-transparent" data-id="element-660" />
            </div>

            {/* Content */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="relative z-10 p-8 md:p-12 w-full flex items-center gap-8" data-id="element-661">
              <div className="flex-1" data-id="element-662">
                <h3 className="text-sm md:text-base font-bold tracking-[0.2em] uppercase mb-4 text-white/80" data-id="element-663">
                  LATEST SERMON
                </h3>
                <h2 className="text-2xl md:text-4xl font-serif font-bold text-white mb-4 leading-tight uppercase" style={{
                textShadow: '0 4px 20px rgba(0,0,0,0.5)'
              }} data-id="element-664">
                  THE POWER OF
                  <br data-id="element-665" />
                  THE CROSS
                </h2>
                <div className="flex items-center gap-3 text-white/60 uppercase tracking-widest text-xs font-bold" data-id="element-666">
                  <div className="h-[1px] w-6 bg-white/30" data-id="element-667" />
                  <span data-id="element-668">Latest Message</span>
                  <div className="h-[1px] w-6 bg-white/30" data-id="element-669" />
                </div>
              </div>

              <a href="https://youtube.com/@householdchurch" target="_blank" rel="noopener noreferrer" className="shrink-0" data-id="element-670">
                <div className="w-16 h-16 md:w-20 md:h-20 bg-[#C8102E] rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 shadow-[0_0_30px_rgba(200,16,46,0.5)] cursor-pointer" data-id="element-671">
                  <Play className="w-7 h-7 md:w-8 md:h-8 text-white ml-1" fill="currentColor" data-id="element-672" />
                </div>
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      <ServiceFlyers data-id="element-673" />

      {/* SECTION 4: UPCOMING EVENTS + GIVE ONLINE */}
      <section className="bg-white" data-id="element-674">
        <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-675">
          {/* Left Side: Events */}
          <div className="p-8 md:p-12 lg:p-16 lg:pr-8 xl:pl-[8%] 2xl:pl-[15%] bg-[#F5F7FA]" data-id="element-676">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-677">
              <div className="flex items-center gap-3 mb-8" data-id="element-678">
                <h2 className="text-xl md:text-2xl font-serif font-bold text-[#0A1F44] uppercase tracking-widest italic" data-id="element-679">
                  UPCOMING EVENTS
                </h2>
                <Link to="/events" className="text-[#C8102E] hover:text-[#A00D24] transition-colors" data-id="element-680">
                  <ArrowRight className="w-5 h-5" data-id="element-681" />
                </Link>
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-682">
                {/* Event 1 */}
                <Link to="/events" className="group relative h-36 md:h-44 rounded-xl overflow-hidden shadow-lg block" data-id="element-683">
                  <img src="https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Revival Night" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-684" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F44]/90 via-[#0A1F44]/40 to-transparent" data-id="element-685" />
                  <div className="absolute inset-0 p-4 flex flex-col justify-end" data-id="element-686">
                    <h3 className="text-white font-serif font-bold text-base md:text-lg uppercase tracking-wide" data-id="element-687">
                      REVIVAL NIGHT
                    </h3>
                    <p className="text-white/90 font-bold tracking-widest text-sm" data-id="element-688">
                      May 18
                    </p>
                  </div>
                </Link>

                {/* Event 2 */}
                <Link to="/events" className="group relative h-36 md:h-44 rounded-xl overflow-hidden shadow-lg block" data-id="element-689">
                  <img src="https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Prayer Conference" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-690" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F44]/90 via-[#0A1F44]/40 to-transparent" data-id="element-691" />
                  <div className="absolute inset-0 p-4 flex flex-col justify-end" data-id="element-692">
                    <h3 className="text-white font-serif font-bold text-base md:text-lg uppercase tracking-wide" data-id="element-693">
                      PRAYER CONFERENCE
                    </h3>
                    <p className="text-white/90 font-bold tracking-widest text-sm" data-id="element-694">
                      June 7 – 9
                    </p>
                  </div>
                </Link>
              </div>
            </motion.div>
          </div>

          {/* Right Side: Give Online */}
          <div className="relative min-h-[280px] lg:min-h-full flex items-center justify-center overflow-hidden" data-id="element-695">
            {/* Background Image */}
            <div className="absolute inset-0" data-id="element-696">
              <img src="https://images.unsplash.com/photo-1504052434569-70ad5836ab65?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Give Online" className="w-full h-full object-cover" data-id="element-697" />
              <div className="absolute inset-0 bg-[#0A1F44]/50" data-id="element-698" />
            </div>

            {/* Content */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="relative z-10 text-center p-10 w-full max-w-md" data-id="element-699">
              <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-4 uppercase tracking-widest" style={{
              textShadow: '0 4px 20px rgba(0,0,0,0.5)'
            }} data-id="element-700">
                GIVE ONLINE
              </h2>

              <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed font-medium" style={{
              textShadow: '0 2px 10px rgba(0,0,0,0.5)'
            }} data-id="element-701">
                Support the Work
                <br data-id="element-702" />
                of the Kingdom
              </p>

              <Link to="/give" data-id="element-703">
                <Button variant="primary" size="md" className="font-bold tracking-widest px-8 shadow-lg shadow-red-900/40" data-id="element-704">
                  GIVE NOW <ArrowRight className="w-5 h-5 ml-2" data-id="element-705" />
                </Button>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    </Layout>;
}